const centralLevelServicesCategories = {
  GeneralServices: 1,
  TherapyServices: 2,
  AditionalServices: 3,  
};

export default centralLevelServicesCategories;

